<template>
  <!--权益 -->
  <div class="wrapper">
    <!-- 被保险人 -->
    <div class="base">
      <div class="title">被保险人</div>
      <div class="content">
        <div class="item" v-for="(item,index) in obj.insuresList" style="position:relative">
          <div class="num" v-if="obj.insuresList&&obj.insuresList.length>1">
            <span>{{index+1}}</span>
          </div>
          <div class="top clearfix">
            <div class="its">
              <div class="label">姓名</div>
              <div class="value">{{item.name}}</div>
            </div>
            <div class="its">
              <div class="label">性别</div>
              <div class="value">{{item.sex | filterSex}}</div>
            </div>
            <div class="its">
              <div class="label">证件类型</div>
              <div class="value">{{item.cardType | filterCardType}}</div>
            </div>
            <div class="its">
              <div class="label">证件号</div>
              <div class="value" v-if="!item.eyeShow1">{{item.cardNumber}}</div>
              <div class="value" v-else>{{item.cardNumber1}}</div>
              <span v-if="item.cardNumber">
                <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow1" @click="openEye(item,'eyeShow1','cardNumber',index,2)"></i>
                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(item,'eyeShow1','cardNumber',index,2)"></i>
              </span>
              
            </div>
            <div class="its">
              <div class="label">手机号</div>
              <div class="value" v-if="!item.eyeShow">{{item.mobile}}</div>
              <div class="value" v-else>{{item.mobile1}}</div>
              <span v-if="item.mobile">
                <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow" @click="openEye(item,'eyeShow','mobile',index,2)"></i>
                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(item,'eyeShow','mobile',index,2)"></i>
              </span>
            </div>
            <div class="its">
              <div class="label">与投保人关系</div>
              <div class="value">{{item.relationToHolder | filterRelationShip}}</div>
            </div>
          </div>
          <div class="list">
            <div class="title clearfix">
              <div class="left">保障项目</div>
              <div class="right">保额/详情</div>
            </div>
            <ul v-if="obj.rightList">
              <li class="clearfix" v-for="(its,idx) in computedRightList(item.md5CardNumber)" :key="idx">
                <span>{{its.rightName}}</span>
                <span>{{its.rightValue}}</span>
              </li>
              <!-- <li class="clearfix">
                <span>25种中症疾病保险金</span>
                <span>6万元</span>
              </li>
              <li class="clearfix">
                <span>25种中症疾病保险金</span>
                <span>6万元</span>
              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 受益人 -->
    <div class="rights">
      <div class="title">受益人</div>
      <div class="desc">
        <span style="color: #727C8E;">受益人类型：</span>
        <lzDicTxt style="color: #272933;" dicType="BENEFICIARY_TYPE" :dicCode="obj.beneficiaryType"></lzDicTxt>
      </div>
      <div class="content" v-if="obj.beneficiaryType == 2">
        <Table :columns="columns" :data="obj.beneficiaryList" border>
          <template slot-scope="{ row,index }" slot="cardNumber">
          <div class="value" v-if="!row.eyeShow">{{row.cardNumber}}</div>
          <div class="value" v-else>{{row.cardNumber1}}</div>
          <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row,'eyeShow','cardNumber',index,3)"></i>
          <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row,'eyeShow','cardNumber',index,3)"></i>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import filter from "@/api/filter";
import {common} from "@/api/mixins";
export default {
  components: {lzDicTxt},
  mixins:[common],
  props: ["obj"],
  data() {
    return {
      columns: [
        {
          title: "姓名",
          key: "name",
          align: "center"
        },
        {
          title: "证件号码",
          slot: "cardNumber",
          align: "center"
        },
        {
          title: "与被保险人关系",
          key: "relationToHolder",
          align: "center",
          render(h, params) {
            const value = filter.filterRelationShip(
              params.row.relationToHolder
            );
            return <span>{value}</span>;
          }
        },
        {
          title: "受益比例",
          key: "rate",
          align: "center",
          render(h, params) {
            return <span>{params.row.rate + "%"}</span>;
          }
        }
      ]
    };
  },
  watch: {},
  methods: {
    computedRightList(md5CardNumber){
      if(!md5CardNumber){
        return [];
      }
      let out = [];
      this.obj.rightList.forEach(item2=>{
        if(md5CardNumber==item2.insuresCardNo){
          out = out.concat(item2.rightList);
        }
      });
      return out;
    },
    openEye(item,keyName,name,index,type){
      let operationType
      if(name == 'mobile'){
        operationType=2
      }else if(name =='cardNumber'){
        operationType=1
      }
      if(!item[keyName]){
        this.descrypt({
          query:this.obj.orderNo,
          operationFunction:14,
          operationType:operationType,
          otherInfo:{
            type:type,
            index:index
          }
        },item,name+'1','order_10_6').then(()=>{
          this.$set(item, keyName, true);
        })
      }else{
        this.$set(item, keyName, false);
      }
    },
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "./interests.scss";
.num {
  position: absolute;
  width: 0;
  height: 0;
  /* 设置边框 */
  border: 20px solid;
  top: 0;

  /* 边框颜色 */
  border-color: #ff7134 transparent transparent #ff7134;
  left: 0;
  span {
    position: absolute;
    top: -17px;
    left: -10px;
    color: #fff;
  }
}
</style>